let OAUTH = '';
let ADM = '';
let API = '';

if (process.env.REACT_APP_ENV === 'prod') {
  // prod
  OAUTH = 'https://oauth.azagros.com';
  ADM = 'https://adm.azagros.com';
  API = 'https://api.azagros.com';
} else if (process.env.REACT_APP_ENV === 'homolog') {
  // test
  OAUTH = 'https://homolog-oauth.azagros.com';
  ADM = 'https://homolog-adm.azagros.com';
  API = 'https://homolog-api.azagros.com';
} else if (process.env.REACT_APP_ENV === 'develop') {
  // develop
  OAUTH = 'https://oauth-develop.azagros.com';
  ADM = 'https://adm-develop.azagros.com';
  API = 'https://api-develop.azagros.com';  
} else if (process.env.REACT_APP_ENV === 'local') {
  //local
  OAUTH = 'https://homolog-oauth.azagros.com';
  ADM = 'https://homolog-adm.azagros.com';
  API = 'https://homolog-api.azagros.com';
}

export default {
  OAUTH: OAUTH,
  ADM: ADM,
  API: API
};
